import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';

import { ConnectivityService } from './core/services/connectivity.service';
import { PwaService } from './core/services/pwa.service';
import { SecurityService } from './core/services/security.service';
import { WebSocketService } from './core/services/web-socket.service';
import { ClientDeviceStateService } from './core/states/client-device-state.service';
import { HomeStateService } from './core/states/home-state.service';
import { LiveQuizStateService } from './core/states/live-quiz-state.service';
import { NotificationHubStateService } from './core/states/notification-hub.state.service';
import { UserInsightStateService } from './core/states/user-insight-state.service';
import { UserProfileStateService } from './core/states/user-profile.state.service';
import { LocalStorageKeys } from './shared/helpers/app.constants';
import { AppUtils } from './shared/helpers/app.utils';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ReactiveFormsModule,
    MatDialogModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private readonly router: Router,
    private readonly securityService: SecurityService,
    private readonly homeStateService: HomeStateService,
    private readonly liveQuizStateService: LiveQuizStateService,
    private readonly userInsightStateService: UserInsightStateService,
    private readonly appUtils: AppUtils,
    private readonly notificationHubStateService: NotificationHubStateService,
    private readonly webSocketService: WebSocketService,
    private readonly userProfileStateService: UserProfileStateService,
    private readonly _: ClientDeviceStateService,
    private readonly _pwaService: PwaService,
    private readonly _connectivityService: ConnectivityService,

  ) {
    this.appUtils.initOSDetection();
  }

  ngOnInit(): void {
    if (this.appUtils.isTokenValid() && !this.userProfileStateService.isSponsor) {
      this.homeStateService.initialState();
      this.appUtils.runAfterRender(() => {
        this.liveQuizStateService.updateLiveQuizState();
      });
    }
    this.userInsightStateService.startBackground();

    window.addEventListener('pagehide', this.onPageHide);
    window.addEventListener('pageshow', this.onPageShow);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;

        const urlObj = new URL(window.location.origin + url);
        const gParam = urlObj.searchParams.get('g');

        if (
          gParam === 'ads' &&
          (urlObj.pathname.includes('/auth/sign-in') || urlObj.pathname.includes('/auth/sign-up'))
        ) {
          this.appUtils.triggerConversion('AW-16762867116/WToHCN7HgrYbEKyblLk-');
        }
      });
    this.appUtils.runAfterRender(() => {
      this.notificationHubStateService.startConnection();
    });
    this.securityService.enableSecurity();
  }

  ngAfterViewInit(): void {
    window.addEventListener('storage', (event) => {
      if (event.storageArea === localStorage) {
        const token = localStorage.getItem(LocalStorageKeys.AuthToken) ?? localStorage.getItem(LocalStorageKeys.GuestToken);
        if (token === null || token === undefined) {
          this.router.navigate(['/auth/sign-in']);
        }
      }
    }, false);
  }


  ngOnDestroy(): void {
    this.userInsightStateService.stopBackground();
    window.removeEventListener('pagehide', this.onPageHide);
    window.removeEventListener('pageshow', this.onPageShow);
  }

  onPageHide() {
    this.webSocketService.disconnect();
  };

  onPageShow(event: PageTransitionEvent) {
    if (event.persisted && !this.webSocketService.isConnected()) {
      this.webSocketService.connect();
    }
  };
}
